import { mapActions } from "vuex";
// const noDataMessage = "There is no data to display";

export default {
	props: {
		data: {
			type: Object,
			default: () => null
		},
		alphabet: {
			type: Array,
			default: () => "abcdefghijklmnopqrstuvwxyz".split("")
		},
		source: {
			type: String,
			default: () => null
		},
		errorMessage: {
			type: String,
			default: () => "There is no data to display"
		}
	},
	data() {
		return {
			isFetching: false,
			label: "Loading"
		};
	},
	computed: {
		borderCheck() {
			return this.data.hideborder ? "is-borderless is-shadowless  px-0" : "";
		}
	},
	watch: {
		source(path) {
			this.fetchData(path);
		}
	},
	mounted() {
		if (this.source) {
			this.fetchData(this.source);
		}
	},
	methods: {
		...mapActions({
			fetchSource: "reportRequests/fetch",
			isValid: "reportRequests/valid"
		})
	}
};
